import { useState } from 'react'
import { ObjectBrowseField } from './ObjectBrowseField'
import { RolePickerModal, type RolePickValue } from './RolePickerModal'

type Props = {
  value?: RolePickValue | null
  onChange?: (value: RolePickValue | null) => void
  disabled?: boolean
  className?: string
}

export function RoleBrowseField({ value, onChange, disabled, className }: Props) {
  const [open, setOpen] = useState(false)

  return (
    <>
      <ObjectBrowseField
        name={value?.name}
        placeholder="请选择角色"
        disabled={disabled}
        ariaLabel="选择角色"
        className={className}
        onBrowse={() => setOpen(true)}
      />
      <RolePickerModal
        open={open}
        value={value}
        onCancel={() => setOpen(false)}
        onConfirm={(next) => {
          onChange?.(next)
          setOpen(false)
        }}
      />
    </>
  )
}

export type { RolePickValue }
